import { Config } from '@chegg-wt/core/config'
import {
  SOURCE_STEP,
  FORM_STEP,
  PREMIUM_CITATIONS,
  FREE_CITATIONS,
  CITATIONS_DASHBOARD,
  FOLDERS,
} from '../constants/citationFlow'
import {
  CitationFlowStep,
  CitationsExperience,
  ProjectsExperience,
} from '../types/citation-flow'

const STEPS: CitationFlowStep[] = [SOURCE_STEP, FORM_STEP]

export const citationFlowStepFromString = (
  stepString?: string
): CitationFlowStep | null => STEPS.find((step) => step === stepString) || null

export const getCitationsExperience = (
  isPro: boolean,
  hasPremiumCitations: boolean
): CitationsExperience | null => {
  if (isPro && hasPremiumCitations) return PREMIUM_CITATIONS
  return FREE_CITATIONS
}

export const getProjectsExperience = (): ProjectsExperience => {
  if (Config.hasCitationsDashboard) return CITATIONS_DASHBOARD
  return FOLDERS
}
